import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { createInventoryTags } from '../../../../Inventory/sagas/tag/routines';
import {
  SHOW_ADD_INVENTORY_TAGS_MODAL,
  HIDE_ADD_INVENTORY_TAGS_MODAL,
  RESET_INVENTORY_TAGS_VIEW
} from '../../../../actions/views/inventory/tags';

const initialState = {
  tagsLoaded: false,
  showAddTagsModal: false,
  saving: false,
  saved: false
};

const createTagsHandler = routine => ({
  [routine.REQUEST]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: state => ({ ...state, saving: false, saved: true })
});

export default createReducer(initialState, {
  ...createTagsHandler(createInventoryTags),
  [SHOW_ADD_INVENTORY_TAGS_MODAL]: set('showAddTagsModal', true),
  [HIDE_ADD_INVENTORY_TAGS_MODAL]: set('showAddTagsModal', false),
  [RESET_INVENTORY_TAGS_VIEW]: state => ({
    ...state,
    saving: false,
    saved: false
  })
});
